import React, { Component, lazy } from 'react';
import './Witness.sass';
import Carousel from 'react-elastic-carousel';
import i18n from '../../../../../i18n';
import DataArray from '../../../../../base/config/DataArray';
const Title = lazy(() => import('../../../../component/title/Title'));
const WitnessForm = lazy(() => import('../../../../component/witnessForm/WitnessForm'));

class Witness extends Component {
    render() {
        var dataArray = DataArray.witness;
        var witnessArray = [];

        dataArray.map((data, id) => {
            if (data.area === 'main') {
                if (window.location.pathname.includes('es' || 'pt-br') && data.replaceId !== '') {
                    witnessArray.splice(data.replaceId, 1, data);
                }
                else if (dataArray[`${id}`].language === '')
                    witnessArray.push(data);
            }
            return null;
        });

        return (
            <div className="WitnessArea">
                <div className="WitnessTitleArea">
                    <Title size="Big" type="Secundary" text={i18n.t('Why they love us')} />
                </div>
                <div className="WitnessBigScreenArea">
                    {witnessArray.map((witness, key) => {
                        return (
                            <div key={key} className="WitnessContent">
                                <WitnessForm image={witness.image} logo={witness.logo} name={witness.name} job={witness.job} message={witness.message} />
                            </div>
                        );
                    }
                    )}
                </div>
                <div className="WitnessSlideArea">
                    <Carousel ref={ref => (this.carousel = ref)} showArrows={false} enableSwipe={true} itemsToScroll={1} itemsToShow={1} >
                        {witnessArray.map((witness, key) => {
                            return (
                                <WitnessForm key={key} image={witness.image} logo={witness.logo} name={witness.name} job={witness.job} message={witness.message} />
                            );
                        }
                        )}
                    </Carousel>
                </div>
            </div>
        );
    }
}

export default Witness;
